module.exports = __webpack_public_path__ + "static/img/wode-s.175629d.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/wode-s.png
// module id = QpeJ
// module chunks = 1